import { Text, Tooltip } from "@mantine/core";

import SvgIconRaw from "~/components/SvgIconRaw";

import RoundIconButton from "../Button/RoundIconButton";
import Center from "../Center";
import SvgIcon from "../SvgIcon";

const NoImagePlaceholder = ({
  bgcolor,
  minHeight,
  minWidth,
  onRefresh,
}: {
  bgcolor?: string;
  minHeight?: string | number;
  minWidth?: string | number;
  onRefresh?: () => void;
}) => (
  <Center flex={1} bg={bgcolor} mih={minHeight} miw={minWidth}>
    <SvgIconRaw name="CameraOff" size={24} />
    <Text size="xs">No image</Text>
    {onRefresh && (
      <Tooltip label="Retry loading image">
        <RoundIconButton
          onClick={onRefresh}
          size="md"
          data-testid="refresh-image-button"
        >
          <SvgIcon name="Refresh" size="1.25rem" />
        </RoundIconButton>
      </Tooltip>
    )}
  </Center>
);

export default NoImagePlaceholder;
